import React from 'react';

const Filter = ({ sections, difficulties, selectedFilters, onFilterChange }) => {
  const handleSectionChange = (e) => {
    const section = e.target.value;
    onFilterChange({ ...selectedFilters, section: section || null });
  };

  const handleDifficultyChange = (e) => {
    const difficulty = e.target.value;
    onFilterChange({ ...selectedFilters, difficulty: difficulty || null });
  };

  const removeFilter = (type) => {
    onFilterChange({ ...selectedFilters, [type]: null });
  };

  // Styles
  const filterContainerStyle = {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    marginBottom: '16px',
    flexWrap: 'wrap'
  };

  const filterSelectStyle = {
    padding: '6px 10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '12px',
    background: 'white',
    color: '#1F2937',
    cursor: 'pointer'
  };

  const selectedFilterStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    background: 'white',
    color: '#1F2937',
    padding: '4px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    marginRight: '8px',
    marginBottom: '4px'
  };

  const removeButtonStyle = {
    marginLeft: '6px',
    background: 'none',
    border: 'none',
    color: '#1F2937',
    cursor: 'pointer',
    fontSize: '12px'
  };

  return (
    <div style={filterContainerStyle}>
      {/* Section Filter */}
      <select
        value={selectedFilters.section || ''}
        onChange={handleSectionChange}
        style={filterSelectStyle}
      >
        <option value="">Select Section</option>
        {sections.map((section) => (
          <option key={section} value={section}>
            {section}
          </option>
        ))}
      </select>

      {/* Difficulty Filter */}
      <select
        value={selectedFilters.difficulty || ''}
        onChange={handleDifficultyChange}
        style={filterSelectStyle}
      >
        <option value="">Select Difficulty</option>
        {difficulties.map((difficulty) => (
          <option key={difficulty} value={difficulty}>
            {difficulty.charAt(0).toUpperCase() + difficulty.slice(1)}
          </option>
        ))}
      </select>

      {/* Display Selected Filters */}
      <div>
        {selectedFilters.section && (
          <span style={selectedFilterStyle}>
            Section: {selectedFilters.section}
            <button
              onClick={() => removeFilter('section')}
              style={removeButtonStyle}
              aria-label="Remove section filter"
            >
              ✕
            </button>
          </span>
        )}
        {selectedFilters.difficulty && (
          <span style={selectedFilterStyle}>
            Difficulty: {selectedFilters.difficulty.charAt(0).toUpperCase() + selectedFilters.difficulty.slice(1)}
            <button
              onClick={() => removeFilter('difficulty')}
              style={removeButtonStyle}
              aria-label="Remove difficulty filter"
            >
              ✕
            </button>
          </span>
        )}
      </div>
    </div>
  );
};

export default Filter;